import React from 'react';
import { Calendar, Battery, BatteryMedium, BatteryLow } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full bg-cream py-20 px-6 md:px-8" style={{
    paddingTop: '50px',
    paddingBottom: '50px',
    paddingLeft: '15px',
    paddingRight: '15px'
  }} data-id="element-151">
      <div className="max-w-5xl mx-auto" data-id="element-152">
        <div className="text-center mb-16" data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-bold text-text mb-4" data-id="element-154">
            Lo que lo hace diferente
          </h2>
          <p className="text-lg text-text-light max-w-2xl mx-auto" style={{
          fontSize: '22px',
          paddingTop: '10px',
          paddingBottom: '10px',
          paddingLeft: '25px',
          paddingRight: '25px'
        }} data-id="element-155">
            La mayoría de guías fallan porque te dan teoría… cuando tú necesitas
            decisiones pre-hechas.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-start" data-id="element-156">
          {/* Feature 1 */}
          <div className="bg-white p-8 rounded-3xl shadow-sm border border-lavender/20 h-full" style={{
          paddingTop: '20px',
          paddingBottom: '20px'
        }} data-id="element-157">
            <div className="w-12 h-12 bg-lavender-light rounded-2xl flex items-center justify-center mb-6 text-lavender-dark" data-id="element-158">
              <Calendar className="w-6 h-6" data-id="element-159" />
            </div>
            <h3 className="text-2xl font-bold text-text mb-4" data-id="element-160">
              1. Guión de 30 días
            </h3>
            <p className="text-text/80 mb-6" data-id="element-161">
              Cada día tiene una estructura simple para que no tengas que
              pensar:
            </p>
            <ul className="space-y-3" data-id="element-162">
              <li className="flex items-center gap-3 p-3 bg-cream rounded-lg" data-id="element-163">
                <span className="font-semibold text-text" data-id="element-164">Mamá</span>
                <span className="text-text-light text-sm" data-id="element-165">(mínimos)</span>
              </li>
              <li className="flex items-center gap-3 p-3 bg-cream rounded-lg" data-id="element-166">
                <span className="font-semibold text-text" data-id="element-167">Bebé</span>
                <span className="text-text-light text-sm" data-id="element-168">(mínimos)</span>
              </li>
              <li className="flex items-center gap-3 p-3 bg-cream rounded-lg" data-id="element-169">
                <span className="font-semibold text-text" data-id="element-170">Casa</span>
                <span className="text-text-light text-sm" data-id="element-171">(mínimo)</span>
              </li>
              <li className="flex items-center gap-3 p-3 bg-rose-light/40 rounded-lg border border-rose-DEFAULT/30" data-id="element-172">
                <span className="font-semibold text-rose-DEFAULT" data-id="element-173">
                  Versión SOS
                </span>
                <span className="text-text-light text-sm" data-id="element-174">
                  "si hoy todo se cae" (5 min)
                </span>
              </li>
            </ul>
          </div>

          {/* Feature 2 */}
          <div className="bg-white p-8 rounded-3xl shadow-sm border border-lavender/20 h-full" style={{
          paddingTop: '20px',
          paddingBottom: '20px'
        }} data-id="element-175">
            <div className="w-12 h-12 bg-sage/30 rounded-2xl flex items-center justify-center mb-6 text-sage-dark" data-id="element-176">
              <Battery className="w-6 h-6" data-id="element-177" />
            </div>
            <h3 className="text-2xl font-bold text-text mb-4" data-id="element-178">
              2. Tus 3 modos del día
            </h3>
            <p className="text-text/80 mb-6" data-id="element-179">
              Porque no todos los días puedes igual. Elige tu modo al despertar:
            </p>

            <div className="space-y-4 mb-8" data-id="element-180">
              <div className="flex items-center gap-4 p-3 border border-rose-DEFAULT/30 rounded-xl bg-rose-light/10" data-id="element-181">
                <BatteryLow className="w-6 h-6 text-rose-DEFAULT" data-id="element-182" />
                <span className="font-bold text-text" data-id="element-183">Modo Supervivencia</span>
              </div>
              <div className="flex items-center gap-4 p-3 border border-yellow-200 rounded-xl bg-yellow-50" data-id="element-184">
                <BatteryMedium className="w-6 h-6 text-yellow-600" data-id="element-185" />
                <span className="font-bold text-text" data-id="element-186">Modo Estándar</span>
              </div>
              <div className="flex items-center gap-4 p-3 border border-sage rounded-xl bg-sage/10" data-id="element-187">
                <Battery className="w-6 h-6 text-sage-dark" data-id="element-188" />
                <span className="font-bold text-text" data-id="element-189">Modo Buen Día</span>
              </div>
            </div>

            <p className="text-sm italic text-text-light bg-cream p-4 rounded-xl" data-id="element-190">
              "Eso evita el clásico ciclo: 'hoy hice mucho → mañana no puedo →
              me siento culpable → abandono todo'. Aquí no abandonas. Solo
              cambias de modo."
            </p>
          </div>
        </div>
      </div>
    </section>;
}